import React from "react";
import { cn } from "@/lib/utils";
import { VisitReasonApi, colorStyle } from "../../services/visitReasons/types";

type VisitReasonPickerProps = {
  reasons: VisitReasonApi[];
  value: number | null;
  onChange: (visitReasonId: number) => void;
  disabled?: boolean;
};

/**
 * Choix du motif de visite en un clic (boutons radio visuels), dans l'ordre
 * d'affichage du catalogue. Un seul motif sélectionnable.
 */
const VisitReasonPicker: React.FC<VisitReasonPickerProps> = ({ reasons, value, onChange, disabled }) => (
  <div role="radiogroup" aria-label="Motif de visite" className="flex flex-wrap gap-2">
    {reasons.map((reason) => {
      const selected = reason.id === value;
      const style = colorStyle(reason.color);
      return (
        <button
          key={reason.id}
          type="button"
          role="radio"
          aria-checked={selected}
          disabled={disabled}
          onClick={() => onChange(reason.id)}
          className={cn(
            "inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-sm font-medium transition-colors duration-200 disabled:opacity-50",
            selected ? cn(style.badge, "ring-2 ring-offset-1 ring-current") : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50"
          )}
        >
          <span className={cn("h-2 w-2 rounded-full", style.dot)} aria-hidden />
          {reason.label}
        </button>
      );
    })}
  </div>
);

export default VisitReasonPicker;
